/**
 * Blog categories.
 *
 * Aligned with the strategic activation framework:
 *   Activación → Confianza → Movimiento → Preparación → Derivación
 *
 * Add new categories here (with both CA and ES labels) and articles will pick them up.
 */
export const CATEGORIES = {
  activation: {
    slug: "activacio",
    slugEs: "activacion",
    label: { ca: "Activació", es: "Activación" },
    order: 1,
  },
  restart: {
    slug: "tornar-a-comencar",
    slugEs: "volver-a-empezar",
    label: { ca: "Tornar a començar", es: "Volver a empezar" },
    order: 2,
  },
  mobility: {
    slug: "mobilitat-i-cos",
    slugEs: "movilidad-y-cuerpo",
    label: { ca: "Mobilitat i cos", es: "Movilidad y cuerpo" },
    order: 3,
  },
  confidence: {
    slug: "confianca-i-autoconcepte",
    slugEs: "confianza-y-autoconcepto",
    label: { ca: "Confiança i autoconcepte", es: "Confianza y autoconcepto" },
    order: 4,
  },
  shame: {
    slug: "vergonya-i-barreres",
    slugEs: "verguenza-y-barreras",
    label: { ca: "Vergonya i barreres emocionals", es: "Vergüenza y barreras emocionales" },
    order: 5,
  },
  preparation: {
    slug: "preparacio-pel-canvi",
    slugEs: "preparacion-para-el-cambio",
    label: { ca: "Preparació pel canvi", es: "Preparación para el cambio" },
    order: 6,
  },
};

export function getCategory(key) {
  return CATEGORIES[key];
}

/** Ordered list of categories for filter UIs. */
export function listCategories() {
  return Object.entries(CATEGORIES)
    .map(([key, cat]) => ({ key, ...cat }))
    .sort((a, b) => (a.order || 99) - (b.order || 99));
}
